'use client';
import Image from 'next/image';
import Link from 'next/link';
import { PortableTextWrapper } from '@/components/PortableTextWrapper';
import type { ArbitraryTypedObject } from '@portabletext/types';
import { PortableTextBlock } from '@sanity/types';
import { getSanityImageUrl } from '@/libs/sanity/client';
import { SlArrowRightCircle } from 'react-icons/sl';
import { BlurInH2 } from '@/components/eldora-ui/blur-in-h2';

type LeftTextBottomRightImageProps = {
  anchor?: string;
  title?: string;
  image: any;
  topContent:
    | (PortableTextBlock | ArbitraryTypedObject)
    | (PortableTextBlock | ArbitraryTypedObject)[];
  leftContent:
    | (PortableTextBlock | ArbitraryTypedObject)
    | (PortableTextBlock | ArbitraryTypedObject)[];
  readMoreLink?: any;
};

const LeftTextBottomRightImage = ({
  anchor,
  title,
  topContent,
  image,
  leftContent,
  readMoreLink,
}: LeftTextBottomRightImageProps) => {
  const isExternal = readMoreLink?.external !== undefined;
  const externalUrl = readMoreLink?.external;

  return (
    <section
      id={anchor}
      className="max-w-8xl flex flex-col gap-x-8 mt-12 lg:mx-auto scroll-mt-[150px]"
    >
      <div className="w-full">
        <BlurInH2>{title}</BlurInH2>
        {topContent && <PortableTextWrapper value={topContent} />}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-0 lg:gap-6 w-full mt-8">
        <div className="col-span-1 lg:col-span-7">
          {leftContent && <PortableTextWrapper value={leftContent} />}
        </div>
        <div className="col-span-1 lg:col-span-5 pb-0 lg:pb-12 pt-0 lg:pt-2">
          <Image
            src={getSanityImageUrl(image)}
            alt="Image"
            className="h-full object-cover object-right"
            loading="lazy"
            width={825}
            height={580}
          />
        </div>
        {isExternal ? (
          <Link
            href={externalUrl}
            className="text-primary mt-4 hover:underline"
          >
            {readMoreLink.label}
            <SlArrowRightCircle className="text-primary" size={18} />
          </Link>
        ) : (
          readMoreLink?.internal?.ref?.metadata?.slug?.current && (
            <Link
              href={readMoreLink.internal.ref.metadata.slug.current || '#'}
              className="text-primary mt-4 hover:underline"
            >
              {readMoreLink.label}
              <SlArrowRightCircle className="text-primary" size={18} />
            </Link>
          )
        )}
      </div>
    </section>
  );
};
export default LeftTextBottomRightImage;
